import Component from '../../js/_Component';

const CNAME = 'c-block-accordion';

/** Generates a relatively unique string suitable for an HTML ID attribute. */
const getUniqueID = () => `d-${Math.random().toString(36).substr(2, 9)}`;

/** Attaches show/hide behavior to a control element and a content element. */
class Disclosure {
	/** The button which toggles the visibility of the content. */
	private control: HTMLButtonElement;

	/** The content which has its visibility toggled. */
	private content: HTMLElement;

	/** The content element's initial CSS display value. */
	private initialDisplay: string;

	constructor(control, content) {
		// Set the class properties.
		this.control = control;
		this.content = content;

		// Store the initial display value of the content (e.g. 'block', 'flex').
		this.initialDisplay = window.getComputedStyle(this.content).display;

		// Set a unique ID for the content element, which the control element references.
		const contentID = getUniqueID();
		this.content.id = contentID;
		this.control.setAttribute('aria-controls', contentID);

		// Set the control's role attribute for accessibility.
		this.control.setAttribute('role', 'button');

		// Set the default state as collapsed.
		this.collapse();

		// Add the click bind for toggling the content's visibility.
		this.control.addEventListener('click', this.toggle.bind(this));
	}

	expand() {
		this.control.setAttribute('aria-expanded', 'true');
		this.content.style.display = this.initialDisplay;
	}

	collapse() {
		this.control.setAttribute('aria-expanded', 'false');
		this.content.style.display = 'none';
	}

	toggle() {
		this.control.getAttribute('aria-expanded') === 'true' ? this.collapse() : this.expand();
	}
}

export default class BlockAccordion extends Component {
	/** The node list of items. */
	private items: NodeListOf<HTMLElement>;

	constructor(element: HTMLElement) {
		super(element);

		this.items = element.querySelectorAll(`.${CNAME}--item`);

		// Attach the disclosure behavior to each item.
		this.items.forEach((item) => {
			const control: HTMLButtonElement = item.querySelector(`.${CNAME}--control`);
			const content: HTMLElement = item.querySelector(`.${CNAME}--content`);
			new Disclosure(control, content);
		});
	}
}

Component.register(BlockAccordion, 'BlockAccordion');
